<ng-container *ngIf="outlets$ | async as outlets">
  <div class="resto-picker" *ngIf="outlets.length > 1; else singleOutlet">
    <div class="resto-picker__item" *ngFor="let outlet of outlets">
      <button class="resto-picker__button button button--th-help" type="button"
              (click)="onChangeMenu(outlet.storeId)"
              [ngClass]="{'is-active': activeOutletId === outlet.storeId}"
      >
        <div class="resto-picker__title h4" *ngIf="outlet.addressDetails">{{ outlet.addressDetails.city }}, {{ outlet.addressDetails.streetLine }}</div>
        <div class="resto-picker__title h4" *ngIf="!outlet.addressDetails">{{ outlet.address }}</div>
        <div class="resto-picker__bottom h5" *ngIf="outletsSchedule && outletsSchedule[outlet.storeId] as schedule">
          <div class="resto-picker__time">
            {{ schedule.open }} – {{ schedule.close }}
          </div>
          <div class="resto-picker__status" *ngIf="schedule.isOpen" i18n="@@Open">Open</div>
          <div class="resto-picker__status _error" *ngIf="!schedule.isOpen" i18n="@@Close">Close</div>
        </div>
        <span class="resto-picker__check">
        <i class="icomoon icomoon--check"></i>
      </span>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #singleOutlet>
  <div class="value-cell">
    <div class="value-cell__title h5" i18n="@@RestaurantAddress">Restaurant address</div>
    <div class="value-cell__text">{{ pickupAddress$ | async }}</div>
  </div>
</ng-template>
